const CLEAR_TIMEOUT = 2000;

export class KeyListener {
	private _isActive: boolean;

	private _sequence: string;
	private _currentAction: (seq: string) => any;

	private _clearTimeout: any;

	constructor() {
		this._sequence = "";
		document.addEventListener("keydown", (e: KeyboardEvent) => {
			if (!this._isActive) {
				return;
			}
			const key = e.key;
			if (key === "Backspace" && this._sequence.length > 0) {
				this._sequence = this._sequence.slice(0, this._sequence.length - 1);
				this._change();
			}
			if (key.length < 2) {
				// handle only single key value
				this._sequence += key;
				this._change();
			}
		});
	}
	public startNewListen(action: (seq: string) => any) {
		this._isActive = true;
		this._sequence = "";
		this._currentAction = action;
	}
	public endListen() {
		this._currentAction = null;
		this.reset();
		this._isActive = false;
	}
	public reset() {
		this._sequence = "";
	}
	private _change() {
		this._currentAction(this._sequence);
		this._addClearTimeout();
	}
	private _addClearTimeout() {
		if (this._clearTimeout) {
			clearTimeout(this._clearTimeout);
		}
		this._clearTimeout = setTimeout(() => {
			this.reset();
			this._clearTimeout = null;
		}, CLEAR_TIMEOUT);
	}
}
